export default "__VITE_ASSET__Yfl35UW1__"